import { render, staticRenderFns } from "./BoxRoomStatus.vue?vue&type=template&id=3dc14564&scoped=true&"
import script from "./BoxRoomStatus.vue?vue&type=script&lang=ts&"
export * from "./BoxRoomStatus.vue?vue&type=script&lang=ts&"
import style0 from "./BoxRoomStatus.vue?vue&type=style&index=0&id=3dc14564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc14564",
  null
  
)

export default component.exports